import { z } from 'zod';

import { ApiFieldRecord } from 'src/types';
import { zodIssuesIntoErrorsMap } from 'src/utils/validation';

export const apiFieldSchema = z.object({
  path: z.string().trim().nonempty(),
});

export const getFormValidator = () => (values: Partial<ApiFieldRecord>) => {
  const validationResult = apiFieldSchema.safeParse(values);
  return validationResult.success ? {} : zodIssuesIntoErrorsMap(validationResult.error.issues);
};
